import { IPersonalInfo, ConfigField } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = Pick<IPersonalInfo, 'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress'>;

export type Visible = Record<'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress', boolean>;

type Mandatory = Record<'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress', boolean>;

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields
): {
  complete: boolean;
  visible: Visible;
} {
  const { phoneNumber, city, country, postCode, homeAddress } = fields;

  const {
    PhoneNumber: phoneNumberConfig,
    HomeAddress: homeAddressConfig,
    City: cityConfig,
    Postcode: postCodeConfig,
    Country: countryConfig
  }: {
    PhoneNumber: ConfigField;
    HomeAddress: ConfigField;
    City: ConfigField;
    Postcode: ConfigField;
    Country: ConfigField;
  } = config.Checklist.PersonalInfo.Page3;

  const visible: Visible = {
    phoneNumber: phoneNumberConfig?.visible,
    city: homeAddressConfig?.visible,
    country: cityConfig?.visible,
    postCode: postCodeConfig?.visible,
    homeAddress: countryConfig?.visible
  };

  const mandatory: Mandatory = {
    phoneNumber: phoneNumberConfig?.mandatory,
    city: homeAddressConfig?.mandatory,
    country: cityConfig?.mandatory,
    postCode: postCodeConfig?.mandatory,
    homeAddress: countryConfig?.mandatory
  };

  // prettier-ignore
  const complete = (!visible.phoneNumber || !mandatory.phoneNumber || phoneNumber !== '') &&
    (!visible.city || !mandatory.city || city !== '') &&
    (!visible.country || !mandatory.country || country !== '') &&
    (!visible.postCode || !mandatory.postCode || postCode !== '') &&
    (!visible.homeAddress || !mandatory.homeAddress || homeAddress !== '');

  return {
    complete,
    visible
  };
}
